export default __webpack_public_path__ + "static/media/google_play.ba054cec.png";